export function createConcurrencyLimiter(maxConcurrent) {
  let activeCount = 0;
  const queue = [];

  function runNext() {
    if (activeCount >= maxConcurrent || queue.length === 0) return;
    const { taskFn, resolve, reject } = queue.shift();
    activeCount += 1;
    Promise.resolve()
      .then(taskFn)
      .then(resolve, reject)
      .finally(() => {
        activeCount -= 1;
        runNext();
      });
  }

  return function schedule(taskFn) {
    return new Promise((resolve, reject) => {
      queue.push({ taskFn, resolve, reject });
      runNext();
    });
  };
}
